export const RESET = 'payment/RESET';
export const SALE_CASH_CHARGE = 'SALE_CASH_CHARGE';
export const SALE_CARD_CHARGE = 'SALE_CARD_CHARGE';
export const SALE_READERLESS_POS_CHARGE = 'SALE_READERLESS_POS_CHARGE';
export const PROCESS_CHARGE = 'payment/PROCESS_CHARGE';
export const PROCESS_WEBREADER_CHARGE = 'payment/PROCESS_WEBREADER_CHARGE';
export const PAYMENT_SUCCESS = 'payment/PAYMENT_SUCCESS';
export const CREATE_READER_TRANSACTION = 'payment/CREATE_READER_TRANSACTION';
export const CREATE_WEBREADER_TRANSACTION = 'payment/CREATE_WEBREADER_TRANSACTION';
export const READER_TRANSACTION_SUCCESS = 'payment/READER_TRANSACTION_SUCCESS';
export const READER_TRANSACTION_FAIL = 'payment/READER_TRANSACTION_FAIL';
export const SET_HANDOFF = 'payment/SET_HANDOFF';
